import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const ArrowIcon = ({ direction = 'forward', type = 'utility', size = 'regular', disabled = false, strokeWidth = 2, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    const rotateDeg = { forward: 0, down: 90, backward: 180, up: 270 }[direction];
    return (React.createElement("svg", { viewBox: "0 0 39 35", width: sizePx, height: sizePx, style: styles, ...rest, role: "img", "aria-label": direction },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M21.648 33.32l7.837-7.835M1 17.323h36.646L21.648 1.325", fillRule: "nonzero", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth, transform: `rotate(${rotateDeg},19.5,17.5)` }))));
};
export default ArrowIcon;
//# sourceMappingURL=index.js.map